import React, { useState } from 'react'

/* LIBS */

import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

/* ICONS */

import { IconContext } from 'react-icons'
import { GrSystem } from 'react-icons/gr'
import {
  FaCalendarCheck,
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin
} from 'react-icons/fa'
import { MdMedicalServices } from 'react-icons/md'
import { HiOutlineBars3 } from 'react-icons/hi2'
import { FaLocationDot } from 'react-icons/fa6'
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded'
import HomeIcon from '@mui/icons-material/Home'
import InfoIcon from '@mui/icons-material/Info'

/* IMAGES */

import { logos } from '../Assets/Logos/logos'

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false)

  const menuOptions = [
    {
      text: 'Home',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <HomeIcon />
        </IconContext.Provider>
      ),
      link: '#'
    },
    {
      text: 'Sobre',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <InfoIcon />
        </IconContext.Provider>
      ),
      link: '#about'
    },
    {
      text: 'Serviços',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <MdMedicalServices />
        </IconContext.Provider>
      ),
      link: '#services-section'
    },
    {
      text: 'Contato',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <PhoneRoundedIcon />
        </IconContext.Provider>
      ),
      link: '#contact-section'
    },
    {
      text: 'Unidades',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <FaLocationDot />
        </IconContext.Provider>
      ),
      link: '#Location-h3'
    },
    {
      text: 'Agende seu exame',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <FaCalendarCheck />
        </IconContext.Provider>
      ),
      link: 'https://asoonline.com.br/sistema/hub.asp'
    },
    {
      text: 'Acesse o Sistema',
      icon: (
        <IconContext.Provider value={{ size: '25px' }}>
          <GrSystem />
        </IconContext.Provider>
      ),
      link: 'https://www.agendatecnica.com.br/v2/login.asp'
    }
  ]

  // scroll top and reload window
  function handleHomeButton(e) {
    e.preventDefault()
    window.scrollTo(window.top)
    window.location.reload()
  }

  // scroll to section
  function scrollWindowToSection(section) {
    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  return (
    <>
      <div className="top-menu">
        <div className="top-menu-social-media">
          <a
            href="https://www.facebook.com/Ammarhesconsultoria/"
            aria-label="https://www.facebook.com/Ammarhesconsultoria/"
            target="_blank"
          >
            <IconContext.Provider value={{ size: '20px', color: '#fff' }}>
              <FaFacebookSquare />
            </IconContext.Provider>
          </a>
          <a
            href="https://www.linkedin.com/in/ammarhesconsultoria/"
            aria-label="https://www.linkedin.com/in/ammarhesconsultoria/"
            target="_blank"
          >
            <IconContext.Provider value={{ size: '20px', color: '#fff' }}>
              <FaLinkedin />
            </IconContext.Provider>
          </a>
          <a
            href="https://www.instagram.com/ammarhesconsultoria/"
            aria-label="https://www.instagram.com/ammarhesconsultoria/"
            target="_blank"
          >
            <IconContext.Provider value={{ size: '20px', color: '#fff' }}>
              <FaInstagram />
            </IconContext.Provider>
          </a>
        </div>
        <div className="top-menu-itens-container">
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">
                  CENTRAL DE AGENDAMENTO:
                </span>{' '}
                SEG - SEX : 07h- 19h
              </p>
            </div>
          </div>
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">
                  HORÁRIO DE ATENDIMENTO DAS CLÍNICAS:
                </span>{' '}
                SEG - SEX : 07h- 11h45
              </p>
            </div>
          </div>
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">CONTATO: </span>
                <a href="mailto:contato@saude10clinica.com.br">
                  comercial@ammarhes.com.br
                </a>
              </p>
            </div>
          </div>
          <div className="top-menu-itens">
            <div className="text-top-menu">
              <p>
                <span className="text-top-menu-span">LIGAR PARA: </span>
                <a href="tel:+552122629752"> +55 &#40;21&#41; 2262-9752</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <nav>
        <div className="nav-logo-container">
          <a href="" onClick={handleHomeButton}>
            <img
              src={logos.ammarhesBlue}
              alt="Logo Ammarhes"
              className="nav-logo"
            />
          </a>
        </div>
        <div className="navbar-links-container">
          <a href="#" onClick={handleHomeButton}>
            Home
          </a>
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              const section = document.querySelector('#about')
              scrollWindowToSection(section)
            }}
          >
            Sobre
          </a>
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              const section = document.querySelector('#services-section')
              scrollWindowToSection(section)
            }}
          >
            Serviços
          </a>
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              const section = document.querySelector('#Location-h3')
              scrollWindowToSection(section)
            }}
          >
            Unidades
          </a>
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              const section = document.querySelector('#contact-section')
              scrollWindowToSection(section)
            }}
          >
            Contato
          </a>
          <a
            href="https://www.agendatecnica.com.br/v2/login.asp"
            target="_blank"
            rel="noreferrer"
          >
            Acesso ao sistema
          </a>
          <a
            href="https://asoonline.com.br/sistema/hub.asp"
            id="agende"
            target="_blank"
            rel="noreferrer"
          >
            Agende seu exame
          </a>
        </div>
        <div className="navbar-menu-container">
          <HiOutlineBars3 onClick={() => setOpenMenu(true)} />
        </div>
        <Drawer
          open={openMenu}
          onClose={() => setOpenMenu(false)}
          anchor="right"
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={() => setOpenMenu(false)}
            onKeyDown={() => setOpenMenu(false)}
          >
            <List>
              {menuOptions.map(item => (
                <ListItem key={item.text} disablePadding>
                  <a
                    href={item.link}
                    target={item.link.includes('http') ? '_blank' : '_self'}
                    className="navbar-menu-link"
                  >
                    <ListItemButton>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText primary={item.text} />
                    </ListItemButton>
                  </a>
                </ListItem>
              ))}
            </List>
            <Divider />
            <div className="infos-mobile">
              <div className="text-top-menu-mobile">
                <p>
                  <span className="text-top-menu-span">
                    Central de agendamento:
                  </span>
                  Seg - Sex : 07h - 19h
                </p>
              </div>
              <div className="text-top-menu-mobile">
                <p>
                  <span className="text-top-menu-span">
                    Horario de atendimento das clínicas:
                  </span>
                  Seg - Sex : 07h - 11h45
                </p>
              </div>
              <div className="text-top-menu-mobile">
                <p>
                  <span className="text-top-menu-span">Contato:</span>
                  <a href="mailto:comercial@ammarhes.com.br">
                    comercial@ammarhes.com.br
                  </a>
                </p>
              </div>
              <div className="text-top-menu-mobile">
                <p>
                  <span className="text-top-menu-span">Ligar para:</span>
                  <a href="tel:+552122629752"> +55 (21) 2262-9752</a>
                </p>
              </div>
            </div>
          </Box>
        </Drawer>
      </nav>
    </>
  )
}

export default Navbar
